import { Outlet } from 'react-router-dom';

import Navbar from '../components/navbar/Navbar';

function ChatLayout() {
  return (
    <main id="chat-layout">
      <Navbar />
      <Outlet />
    </main>
  );
}

export default ChatLayout;
